import type { IStorage } from '../types/common';

/**
 * Implements IStorage using an in-memory object.
 */
class MemoryStorage implements IStorage {
  storage: any;

  constructor() {
    this.storage = {};
  }

  getItem(key: string): Promise<string> {
    if (typeof this.storage[key] === 'undefined') {
      return Promise.resolve('');
    }
    return Promise.resolve(this.storage[key]);
  }

  setItem(key: string, value: string): Promise<void> {
    this.storage[key] = value;
    return Promise.resolve();
  }

  removeItem(key: string): Promise<void> {
    delete this.storage[key];
    return Promise.resolve();
  }
}

export { MemoryStorage };
